module.exports = __webpack_public_path__ + "static/media/hot-gadgets2.ee2a5b60.png";